/**
 * Sprint Dev Theme JavaScript
 * Dark Industrial E-commerce Theme
 */

(function() {
  'use strict';

  // ============================================
  // Mobile Menu
  // ============================================
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuClose = document.querySelector('.mobile-menu-close');

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    if (mobileMenuClose) {
      mobileMenuClose.addEventListener('click', () => {
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    // Close menu when clicking on links
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
  }

  // ============================================
  // Quantity Selector
  // ============================================
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const minusBtn = selector.querySelector('[data-action="minus"]');
    const plusBtn = selector.querySelector('[data-action="plus"]');
    const input = selector.querySelector('input');

    if (minusBtn && plusBtn && input) {
      minusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value) || 1;
        if (currentValue > 1) {
          input.value = currentValue - 1;
          input.dispatchEvent(new Event('change'));
        }
      });

      plusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value) || 1;
        const max = parseInt(input.getAttribute('max')) || 999;
        if (currentValue < max) {
          input.value = currentValue + 1;
          input.dispatchEvent(new Event('change'));
        }
      });
    }
  });

  // ============================================
  // Cart Item Remove
  // ============================================
  document.querySelectorAll('[data-remove-item]').forEach(button => {
    button.addEventListener('click', async () => {
      const key = button.dataset.removeItem;
      const cartItem = button.closest('.cart-item');
      
      // Add loading state
      button.disabled = true;
      if (cartItem) {
        cartItem.style.opacity = '0.5';
      }
      
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: 0
          })
        });
        
        if (response.ok) {
          // Reload page to reflect changes
          window.location.reload();
        } else {
          // Restore state on error
          button.disabled = false;
          if (cartItem) {
            cartItem.style.opacity = '1';
          }
        }
      } catch (error) {
        console.error('Remove item error:', error);
        button.disabled = false;
        if (cartItem) {
          cartItem.style.opacity = '1';
        }
      }
    });
  });

  // ============================================
  // Cart Quantity Update
  // ============================================
  document.querySelectorAll('.cart-item [data-quantity-input]').forEach(input => {
    input.addEventListener('change', async () => {
      const key = input.dataset.key;
      const quantity = parseInt(input.value) || 0;
      const cartItem = input.closest('.cart-item');
      
      if (quantity === 0) {
        // Remove item if quantity is 0
        const removeBtn = cartItem?.querySelector('[data-remove-item]');
        if (removeBtn) {
          removeBtn.click();
          return;
        }
      }
      
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: quantity
          })
        });
        
        if (response.ok) {
          window.location.reload();
        }
      } catch (error) {
        console.error('Update quantity error:', error);
      }
    });
  });

  // ============================================
  // Add to Cart (AJAX)
  // ============================================
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;

      const formData = new FormData(form);
      
      try {
        const response = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          submitBtn.textContent = 'Added!';
          
          // Update cart count
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          updateCartCount(cart.item_count);
          
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        } else {
          const error = await response.json();
          submitBtn.textContent = error.description || 'Error';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        }
      } catch (error) {
        console.error('Add to cart error:', error);
        submitBtn.textContent = 'Error';
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 2000);
      }
    });
  });

  function updateCartCount(count) {
    const cartCountElements = document.querySelectorAll('.cart-count');
    cartCountElements.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // ============================================
  // Variant Selector
  // ============================================
  const variantSelectors = document.querySelectorAll('[data-variant-selector]');

  variantSelectors.forEach(selector => {
    selector.addEventListener('change', (e) => {
      const form = e.target.closest('form');
      const variantId = e.target.value;
      const priceElement = document.querySelector('[data-product-price]');
      const compareAtPriceElement = document.querySelector('[data-compare-at-price]');
      const addToCartBtn = form.querySelector('[type="submit"]');

      // Update variant ID in hidden input
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
      }

      // Get variant data from JSON
      const variantData = window.productVariants?.find(v => v.id == variantId);
      
      if (variantData) {
        // Update price
        if (priceElement) {
          priceElement.textContent = formatMoney(variantData.price);
        }

        // Update compare at price
        if (compareAtPriceElement) {
          if (variantData.compare_at_price && variantData.compare_at_price > variantData.price) {
            compareAtPriceElement.textContent = formatMoney(variantData.compare_at_price);
            compareAtPriceElement.style.display = 'inline';
          } else {
            compareAtPriceElement.style.display = 'none';
          }
        }

        // Update button state
        if (addToCartBtn) {
          if (variantData.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = window.variantStrings?.addToCart || 'Add to Cart';
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = window.variantStrings?.soldOut || 'Sold Out';
          }
        }
      }
    });
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ============================================
  // Specs Accordion
  // ============================================
  const specsAccordions = document.querySelectorAll('.specs-accordion-toggle');

  specsAccordions.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const content = toggle.nextElementSibling;
      const isOpen = toggle.classList.contains('active');

      if (isOpen) {
        toggle.classList.remove('active');
        content.style.maxHeight = '0';
      } else {
        toggle.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  // ============================================
  // Header Scroll Effect
  // ============================================
  let lastScroll = 0;
  const header = document.querySelector('.site-header');

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll > 100) {
      header?.classList.add('scrolled');
    } else {
      header?.classList.remove('scrolled');
    }

    lastScroll = currentScroll;
  });

  // ============================================
  // Product Image Gallery
  // ============================================
  const thumbnails = document.querySelectorAll('[data-thumbnail]');
  const mainImage = document.querySelector('[data-main-image]');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (mainImage) {
        mainImage.src = thumb.dataset.fullImage;
        mainImage.alt = thumb.alt;
      }

      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ============================================
  // Newsletter Form
  // ============================================
  const newsletterForms = document.querySelectorAll('.newsletter-form');

  newsletterForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const submitBtn = form.querySelector('[type="submit"]');
      const emailInput = form.querySelector('input[type="email"]');
      const originalText = submitBtn.textContent;

      submitBtn.textContent = 'Subscribing...';
      submitBtn.disabled = true;

      // Simulate subscription (replace with actual newsletter integration)
      setTimeout(() => {
        submitBtn.textContent = 'Subscribed!';
        emailInput.value = '';
        
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 3000);
      }, 1000);
    });
  });

  // ============================================
  // Lazy Load Images
  // ============================================
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[data-src]');
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          observer.unobserve(img);
        }
      });
    });

    lazyImages.forEach(img => imageObserver.observe(img));
  }

})();
